import { render } from "./RiskQuery.vue?vue&type=template&id=5fb7f48a"
import script from "./RiskQuery.vue?vue&type=script&lang=js"
export * from "./RiskQuery.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__